import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from './Header';
import Footer from './Footer';

/**
 * Main Layout Component
 * Wraps all pages with consistent header and footer
 * SEO-friendly structure
 * AOS.init tek merkezde - tüm sayfalar için bir kez (performans)
 */
const Layout = ({ children }) => {
  useEffect(() => {
    AOS.init({ duration: 600, once: true });
  }, []);

  return (
    <div className="App">
      <Header />
      <main role="main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;

